import axios from 'axios';
import { API, authHeaders } from './client';

export const getPromoCodes = (token) =>
  axios.get(`${API}/promo-codes`, authHeaders(token)).then(r => r.data);

export const createPromoCode = (token, data) =>
  axios.post(`${API}/promo-codes`, data, authHeaders(token)).then(r => r.data);

export const updatePromoCode = (token, id, data) =>
  axios.put(`${API}/promo-codes/${id}`, data, authHeaders(token)).then(r => r.data);

export const deletePromoCode = (token, id) =>
  axios.delete(`${API}/promo-codes/${id}`, authHeaders(token)).then(r => r.data);
